//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import axios from 'axios'

export default {
  data () {
    return {
      days: [],
      location: 'G1',
      locations: ['G1', 'G2', 'G3', 'G4', 'TRM', 'VN2', 'INDO'],
      yrs: '',
      months: [
        '01',
        '02',
        '03',
        '04',
        '05',
        '06',
        '07',
        '08',
        '09',
        '10',
        '11',
        '12'
      ],
      visible: false
    }
  },
  async mounted () {
    await this.defaultPeriod()
  },
  watch: {
    location: function (newValue, oldValue) {
      this.defaultPeriod()
    }
  },
  methods: {
    defaultPeriod () {
      try {
        this.visible = true
        const postjson = {
          yrs: this.yrs,
          loc: this.location,
          grp: this.$route.params.grp
        }
        axios({
          method: 'post',
          url: `${this.$apiflask}nygctroom/setup/holiday`, // php performance_nyg.py
          data: postjson
        }).then(res => {
          this.yrs = res.data.yrs
          this.months = res.data.months
          this.days = res.data.days

          this.visible = false
        })
      } catch (err) {
        this.$q.notify({
          position: 'top-right',
          timeout: 2500,
          textColor: 'white',
          color: 'red',
          message: err,
          html: true
        })
        this.visible = false
      }
    },

    updateData () {
      try {
        this.visible = true
        const postjson = {
          yrs: this.yrs,
          days: this.days,
          loc: this.location,
          grp: this.$route.params.grp
        }
        axios({
          method: 'post',
          url: `${this.$apiflask}nygctroom/setup/holiday/update`, // php
          data: postjson
        }).then(res => {
          // console.log(res.data)
          this.visible = false
        })
      } catch (err) {
        this.$q.notify({
          position: 'top-right',
          timeout: 2500,
          textColor: 'white',
          color: 'red',
          message: err,
          html: true
        })
        this.visible = false
      }
    }
  }
}
